import { FilterMatchMode, FilterOperator } from "primereact/api";
import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import TextInput from "../componets/TextInput";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import DropDown from "../componets/DropDown";
import { eventService } from "../services/EventService";
import AddEvent from "../componets/AddEvent";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
// import EventGroupService from "../services/EventGroupService";
// import EventTypeService from "../services/EventTypeService";
import { AppDB } from "../App";

export const Events = () => {
	const [showAddEventForm, setshowAddEventForm] = useState(false);
	const [showEditEvent, setshowEditEvent] = useState(false);
	const [showDialog, setShowDialog] = useState(false);
	const [eventTypes, setEventTypes] = useState(false);
	var [selectedEventType, setSelectedEventType] = useState("SELECT AN EVENT TYPE");
	var [selectedEventGroupID, setselectedEventGroupID] = useState([]);
	const [objectionNumber, setObjectionNumber] = useState("");
	let [data, setData] = useState([]);
	let [events, setEvents] = useState([]);
	const { groupEventInfo, setgroupEventInfo, toast } = useContext(AppDB);

	
	
	let [ByElecData, setByElecData] = useState([]);
	let [ActiveByElecData, setActiveByElecData] = useState([]);
	var [form, setForm] = useState({
	    eventGroup: "SELECT AN EVENT GROUP",
	    eventType: "SELECT AN EVENT TYPE",
	});
	//var eventGroupService = new EventGroupService();
	// var eventTypeService = new EventTypeService();
	var [eventGroup, setEventGroup] = useState([]);
	var [form2, setForm2] = useState({
	    name: "",
	    description: "",
	    eventDate: "",
	    eventGroupID: null,
	    selectedEventCategory: null,
	    selectedEventType: null,
	    selectedParentEvent: null,
	});
	const [showEditForm, setShowEditForm] = useState(false);

	function deActivateHandler(e) {
	    // eventService.deActivateEvent(e.eventID).then((e) => {
	    //     var id = form.eventGroup?.eventGroupID ? form.eventGroup?.eventGroupID : null;
	    //     if (id == null) return setData([]);
	    //     eventService.getAllEvents(id).then((data) => {
	    //         setData(data);
	    //     });
	    // });
	}

	async function deActivateByelectionHandler(e) {
		
	    await eventService.DeActivateByElection(e?.eventID)
		.then((res) => {

			if(res?.success)
			{
				GetByElections(selectedEvents?.eventID);
			}
			return toast.show({
				severity: res?.success ? "success" : "error",
				summary: "Message",
				detail: res?.message,
				life: 2000,
			});

	    })
		.catch((err) =>{

		});
	}
	async function GetByElections(eventID, ActiveOnly = true)
	{
		await eventService.getAllEvents(
		{
			"ParentEventID":eventID,
			"PageIndex": 1,
			"PageSize":10000,
			"IsByElection":true,
			"ActiveOnly":ActiveOnly
		})
		.then((data) => {
			if(ActiveOnly)
			{
				setActiveByElecData(data);
			}
			else 
			{
				setByElecData(data);
			}
		})
		.catch((err) => {
			console.log(err);
		});
	}
	function formatDate(date) {
	    var d = new Date(date),
	        month = "" + (d.getMonth() + 1),
	        day = "" + d.getDate(),
	        year = d.getFullYear();

	    if (month.length < 2) month = "0" + month;
	    if (day.length < 2) day = "0" + day;

	    return [year, month, day].join("-");
	}
	var submittedForm = false;


    // Load from localStorage when the component mounts
    useEffect(() => {
        const storedData = localStorage.getItem("groupEventInfo");
        if (storedData) {
            setgroupEventInfo(JSON.parse(storedData));
        }
    }, []);
	function submitByElection() {
	    // form2.eventGroupID = form.eventGroup.eventGroupID;
	    // form2.SelectedParentEvent = selectedEvents?.eventID;
	    // console.log(selectedEvents.eventDate_s);
	    // var newForm = {};
	    // Object.keys(form2).map((key) => {
	    //     newForm[key] = form2[key];
	    // });
	    // newForm["eventDate"] = formatDate(form2.eventDate) + " 00:00";
	    // var error = false;
	    // Object.keys(newForm).map((key) => {
	    //     var value = newForm[key];
	    //     if (value === "") {
	    //         error = true;
	    //     }
	    // });
	    // const date1 = new Date(selectedEvents.eventDate_s);
	    // const date2 = new Date(newForm["eventDate"]);
	    // const diffTime = date2 - date1;
	    // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	    // if (diffDays <= 0) {
	    //     toast.show({ severity: "error", summary: "Error Message", detail: "Invalid date, the date of the By-Election should be at least a day after the Event", life: 5000 });
	    //     return false;
	    // }
	    // console.log(diffDays + " days");
	    // console.log(new Date());
	    // console.log(newForm);
	    // if (error == true) {
	    //     toast.show({
	    //         severity: "error",
	    //         summary: "Error Message",
	    //         detail: "please fill the required fields",
	    //         life: 2000,
	    //     });
	    //     return false;
	    // }
		
		var payload = 
		{
			"eventGroupID":selectedEvents.eventGroupID,
			"EventTypeID": selectedEvents.eventTypeID,
			"Name":form2?.name,
			"Description":form2.description,
			"ParentEventID": selectedEvents?.eventID,
			"EventDate_s": form2?.eventDate,
			"EventDate": form2?.eventDate
		}

		eventService.create(payload)
		.then((res) => {
			submittedForm = res?.success;
			if(res?.success)
			{

				eventService.getAllEvents({
					"EventGroupID":payload?.eventGroupID,
					"PageIndex": 1,
					"PageSize":10000
				}).then((data) => {
					setData(data);
					setshowEditEvent(false);
					setForm2(" ");
				})
				.catch((err) =>{
					
					console.log(err);
				})
			}

			return toast.show({ 
				severity: res?.success? "success": "error", 
				summary: "Message", 
				detail: res?.message, 
				life: 2000 });
		})
		.catch((err) => {
			submittedForm = false;
			return toast.show({
				severity: "error",
				summary: "Error Message",
				detail: "Ooops, The is a technical problem,Please Try Again",
				life: 3000
			});
		});
	    // var eventService = new EventService();
	    // eventService
	    //     .createEvent(newForm)
	    //     .then((res) => {
	    //         submittedForm = true;
	    //         eventService.getAllEvents(form.eventGroup.eventGroupID).then((data) => {
	    //             setData(data);
	    //             setshowEditEvent(false);
	    //             setForm2(" ");
	    //             return toast.show({
	    //                 severity: "success",
	    //                 summary: "Success Message",
	    //                 detail: "By-election was added successfully",
	    //                 life: 2000,
	    //             });
	    //         });
	    //     })
	    //     .catch((e) => {
	    //         submittedForm = false;
	    //         return toast.show({
	    //             severity: "error",
	    //             summary: "Error Message",
	    //             detail: "Ooops, The is a technical problem,Please Try Again",
	    //             life: 3000,
	    //         });
	    //     });
	}
	useEffect(() => {
		GetEventGroups();
		GetEventTypes();
	}, []);
	async function GetEventGroups()
	{
		
		await eventService.getAllGroups()
		.then((data) => {
			
			setEventGroup(data);;
		})
		.catch((err) => {
			return toast.show({ severity: "error", summary: "Error Message", detail: "Could not get event groups", life: 4000 });
		});

	}
	async function GetEventTypes()
	{
		await eventService.getEventTypes()
		.then((data) => {
			
			setEventTypes(data);
		})
		.catch((err) => {
			return toast.show({ severity: "error", summary: "Error Message", detail: "Could not get event types", life: 4000 });
		});

	}

	
	function byElectionHandler() {
		
	    // eventService.getByElections(selectedEvents?.eventID).then((data) => {
	    //     setByElecData(data.reverse());
	    // });
	    // eventService.getActiveByElections(selectedEvents?.eventID).then((data) => {
	    //     setActiveByElecData(data);
	    // });
		GetByElections(selectedEvents?.eventID);
		GetByElections(selectedEvents?.eventID, false);
	}

	var getInput = (key, ev) => {
	    setForm({ ...form, [key]: ev.value });
	};
	const [globalFilterValue, setGlobalFilterValue] = useState("");
	const [filters, setFilters] = useState({
	    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
	    name: {
	        operator: FilterOperator.AND,
	        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
	    },
	});
	const onGlobalFilterChange = (e) => {
	    const value = e.target.value;
	    let _filters1 = { ...filters };
	    _filters1["global"].value = value;
	    setFilters(_filters1);
	    setGlobalFilterValue(value);
	};
	const [selectedEvents, setSelectedEvents] = useState(null);
	const [selectedByElection, setSelectedByElection] = useState(null);

	function EventDetails() {
	    return [
	        {
	            name: "Name",
	            value: selectedEvents?.name,
	        },
	        {
	            name: "Description",
	            value: selectedEvents?.description,
	        },
	    ];
	}

	const header = (
	    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
	        <h5 className="m-0">Events</h5>
	    </div>
	);
	//var eventService = new EventService();
	function eventGroupChangeHandler(e) {
		
	    setselectedEventGroupID(e.value.eventGroupID);
	    setForm({ ...form, eventGroup: e.value });
	    var id = e.value?.eventGroupID ? e.value.eventGroupID : null;
	    if (id == null) return setData([]);
	    // eventService.getAllEvents(id).then((data) => {
	    //     setData(data);
	    //     setSelectedEventType("SELECT AN EVENT TYPE");
	    // });



		GetAllEvents(e);
	}
	async function GetAllEvents(e)
	{
		await eventService.getAllEvents(
		{
			"EventGroupID":e?.value?.eventGroupID ? e?.value?.eventGroupID : null,
			"PageIndex": 1,
			"PageSize":10000
		})
		.then((data) => {
	        setEvents(data);
	        setSelectedEventType("SELECT AN EVENT TYPE");
	    })
		.catch((err) =>{
			console.log(err);
		});
	}
	function eventTypeChangeHandler(e) {
		
	    setSelectedEventType(e.value);
	    setForm({ ...form, eventType: e.value });
	    var id1 = selectedEventGroupID;
	    if (id1 == "") {
	        toast.show({ severity: "error", summary: "Error Message", detail: "An event group should be selected first", life: 4000 });
	        return false;
	    }
	    if (id1 != "") {
	        var id2 = e.value?.Value ? e.value.Value : null;
	        if (id2 == null) return setData([]);
	        // eventService.getEventBasedOnGroupAndType(id1, id2).then((data) => {
	        //     setData(data);
	        // });
	    }
	}
	return (
		<div className="card  p-align-stretch vertical-container">
		    <div className="">
		        <Toolbar
		            className="mb-4"
		            left={
		                <div>
		                    <span className="block mt-2 md:mt-0 p-input-icon-left">
		                        <div className="grid">
		                            <div className="col-12  lg:col-5">
		                                <DropDown 
											style={{ maxWidth: 300 }} 
											label={"Event Group"}
											optionLabel="name" 
											onChange={(e) => eventGroupChangeHandler(e)} options={eventGroup||[]} 
											value={form.eventGroup} className="ml-4" 
										 />
		                            </div>
		                            <div className="col-12  lg:col-5">
		                                <DropDown 
											style={{ maxWidth: 300 }} 
											label={"Event Type"} 
											options={eventTypes||[]} 
											onChange={(e) => eventTypeChangeHandler(e)} 
											optionLabel="text" 
											value={selectedEventType} 
											className="ml-4" 
										/>
		                            </div>
		                        </div>
		                    </span>
		                </div>
		            }
		        ></Toolbar>
		        <Toolbar
		            className="mb-4"
		            left={<div>
					<Button 
					className="p-button-success mr-2"
					 icon="pi pi-plus" label="Add Event" 
					 onClick={(e) => setshowAddEventForm(true)} disabled={form?.eventGroup?.status == 0}/> </div>}
		            right={
		                <div>
		                    <span className="block mt-2 md:mt-0 p-input-icon-left">
		                        <i className="pi pi-search" />
		                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search Event Name" />
		                    </span>
		                </div>
		            }
		        ></Toolbar>
		    </div>
		    <Dialog
		        draggable={false}
		        header={<span>{`Event Details - ${selectedEvents?.name} `}</span>}
		        footer={<></>}
		        visible={showEditEvent}
		        style={{ width: "95%", height: "95%" }}
		        modal
		        onShow={() => {
		            byElectionHandler();
		        }}
		        onHide={(e) => {
		            setshowEditEvent(false);
		        }}
		    >
		        <TabView>
		            <TabPanel header="Edit Event">
		                <div className="grid">
		                    <div className="col-12  lg:col-6">
		                        <TextInput label="Name" value={selectedEvents?.name} disabled={true} />
		                    </div>
		                    <div className="col-12  lg:col-6">
		                        <TextInput label="Description" value={selectedEvents?.description} onChange={(e) => setSelectedEvents({ ...selectedEvents, Description: e.target.value })} />
		                    </div>
		                </div>
		                <Button
		                    label="Submit"
		                    // onClick={onEditHandler}
		                    className="p-button-success"
		                    icon="pi pi-plus"
		                    type="submit"
		                />
		            </TabPanel>
		            <TabPanel header="By-Elections">
		                {ActiveByElecData?.length > 0 && ActiveByElecData[0]?.isActive == 1 ? (
		                    <DataTable
		                        size="small"
		                        scrollable={true}
		                        value={ActiveByElecData||[]}
		                        dataKey="eventID"
		                        rows={5}
		                        className="datatable-responsive"
		                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} By-Elections"
		                        emptyMessage="No By-Election found."
		                        eventGroup=""
		                        responsiveLayout="scroll"
		                        selection={selectedByElection}
		                        onSelectionChange={(e) => setSelectedByElection(e.value)}
		                        resizableColumns
		                        columnResizeMode="expand"
		                        filters={filters}
		                        filterDisplay="name"
		                        globalFilterFields={["name"]}
		                    >
		                        <Column field="name" header="Name" sortable></Column>
		                        <Column field="description" header="Description"></Column>
		                        <Column field="eventDate_s" header="Date"></Column>
		                        <Column
		                            field="active"
		                            header="Status"
		                            body={(e) =>
		                                parseInt(e.isActive) == 1 ? (
		                                    <Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" />
		                                ) : (
		                                    <Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
		                                )
		                            }
		                        ></Column>
		                        <Column
		                            field="actions"
		                            header="Actions"
		                            body={(e) => (
		                                <>
		                                    <Button
		                                        onClick={(a) => {
		                                            deActivateByelectionHandler(e);
		                                        }}
		                                        style={{ textAlign: "center", width: "30px", height: "30px" }}
		                                        icon={"pi pi-times"}
		                                        className="p-button-danger p-button-rounded mr-2"
		                                        tooltip="Click to De-Activate"
		                                    />
		                                </>
		                            )}
		                        ></Column>
		                    </DataTable>
		                ) : (
		                    <div className="grid">
		                        <div className="col-12  lg:col-4">
		                            <TextInput label="Event Name" value={form2.name} onChange={(e) => setForm2({ ...form2, name: e.target.value })} />
		                        </div>
		                        <div className="col-12  lg:col-4">
		                            <TextInput label="Description" value={form2.description} onChange={(e) => setForm2({ ...form2, description: e.target.value })} />
		                        </div>
		                        <div className="col-12  lg:col-4">
		                            <TextInput type="Calendar" label="Event Date" value={form2.eventDate} onChange={(e) => setForm2({ ...form2, eventDate: e.target.value })} />
		                        </div>
		                        <br />
		                        <Button label="Add By-Election" onClick={submitByElection} className="p-button-success" icon="pi pi-plus" type="submit" />
		                    </div>
		                )}
		            </TabPanel>
		        </TabView>
		    </Dialog>

		    <Dialog
		        draggable={false}
		        header={
		            <>
		                <li className="pi pi-eye"> </li>
		                <span>{` Event Details - ${selectedEvents?.name} `}</span>
		            </>
		        }
		        visible={showDialog}
		        style={{ width: "95%", height: "95%" }}
		        modal
		        onShow={() => {
		            byElectionHandler();
		        }}
		        onHide={(e) => {
		            setShowDialog(false);
		        }}
		    >
		        <TabView>
		            <TabPanel header={`Event Details for ${selectedEvents}` }>
		                <DataTable size="small" scrollable={true} value={EventDetails()||[]} dataKey="id" responsiveLayout="scroll" resizableColumns>
		                    <Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
		                    <Column body={(e) => e.value}></Column>
		                </DataTable>
		            </TabPanel>
		            <TabPanel header="By-Elections">
		                <DataTable
		                    size="small"
		                    scrollable={true}
		                    value={ByElecData||[]}
		                    dataKey="eventID"
		                    rows={5}
		                    rowsPerPageOptions={[5, 10, 25]}
		                    className="datatable-responsive"
		                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} By-Elections"
		                    emptyMessage="No By-Election found."
		                    eventGroup=""
		                    responsiveLayout="scroll"
		                    selection={selectedByElection}
		                    onSelectionChange={(e) => setSelectedByElection(e.value)}
		                    resizableColumns
		                    columnResizeMode="expand"
		                    filters={filters}
		                    filterDisplay="name"
		                    globalFilterFields={["name"]}
		                >
		                    <Column field="name" header="Name" sortable></Column>
		                    <Column field="description" header="Description"></Column>
		                    <Column field="eventDate_s" header="Date"></Column>
		                    <Column
		                        field="active"
		                        header="Status"
		                        body={(e) =>
		                            parseInt(e.isActive) == 1 ? (
		                                <Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" />
		                            ) : (
		                                <Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
		                            )
		                        }
		                    ></Column>
		                </DataTable>
		            </TabPanel>
		        </TabView>
		    </Dialog>
		    <AddEvent 	showAddEvent={showAddEventForm}
					setShowAddEvent={setshowAddEventForm}
				setData={setEvents} 
				eventGroup={form.eventGroup} 
				eventTypes = {eventTypes}
			/>
		    <DataTable
		        size="small"
		        scrollable={true}
		        value={events||[]}
		        dataKey="id"
		        paginator
		        rows={5}
		        rowsPerPageOptions={[5, 10, 25]}
		        className="datatable-responsive"
		        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Events"
		        emptyMessage="No Events found."
		        header="Events"
		        eventGroup=""
		        responsiveLayout="scroll"
		        selection={selectedEvents}
		        onSelectionChange={(e) => setSelectedEvents(e.value)}
		        resizableColumns
		        columnResizeMode="expand"
		        filters={filters}
		        filterDisplay="name"
		        globalFilterFields={["name"]}
		    >
		        <Column field="name" header="Name" sortable></Column>
		        <Column
		            field="active"
		            header="status"
		            body={(e) =>
		                parseInt(e.isActive) === 1 ? <Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" /> : <Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
		            }
		        ></Column>
		        <Column
		            field="actions"
		            header="Actions"
		            body={(e) => (
		                <>
		                    {parseInt(e.isActive) == 1 ? (
		                        <Button
		                            style={{ textAlign: "center", width: "30px", height: "30px" }}
		                            icon={"pi pi-pencil"}
		                            className="p-button-primary p-button-rounded mr-2 "
		                            tooltip="Click to Edit"
		                            onClick={(a) => {
		                                setshowEditEvent(true);
		                                setSelectedEvents(e);
		                            }}
		                        />
		                    ) : (
		                        <Button 
								style={{ textAlign: "center", width: "30px", height: "30px" }} 
								icon={"pi pi-recycle"} 
								className="p-button-primary p-button-rounded mr-2 "
								 tooltip="Click to Edit" 
								 onClick={(a) => {
									setshowEditEvent(true);
									setSelectedEvents(e);
								}}
								 />
		                    )}
		                    <Button
		                        style={{ textAlign: "center", width: "30px", height: "30px" }}
		                        icon={"pi pi-eye"}
		                        tooltipOptions={{ position: "top" }}
		                        className="p-button-primary p-button-rounded mr-2"
		                        tooltip="Click to View"
		                        onClick={(a) => {
		                            setShowDialog(true);
		                            setSelectedEvents(e);
		                        }}
		                    />
		                    {/* {parseInt(e.IsActive) == 1 ? (
		                        <Button onClick={(aa) => deActivateHandler(e)} style={{ textAlign: "center", width: "30px", height: "30px" }} icon={"pi pi-times"} className="p-button-danger p-button-rounded mr-2" tooltip="Click to De-Activate" />
		                    ) : (
		                        <Button disabled style={{ textAlign: "center", width: "30px", height: "30px" }} icon={"pi pi- pi-times"} className="p-button-danger p-button-rounded mr-2" tooltip="Click to Activate" />
		                    )} */}
		                </>
		            )}
		        ></Column>
		    </DataTable>
		</div>
	);
};
